import React, { useState, useRef, useEffect } from "react";
import Dropzone from "react-dropzone";
import AvatarEditor from "react-avatar-editor";

const AvatarUploader = ({ avatar, setAvatar }) => {
  const editorRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    // Se un avatar è già stato passato in input, impostalo nel componente
    if (avatar) {
      setScale(1); // Resetta la scala quando un nuovo avatar viene caricato
      setImageLoaded(false);
    }
  }, [avatar]);

  const handleDrop = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      console.log("File caricato:", file.name, file.type, file.size);

      const reader = new FileReader();
      reader.onload = (e) => {
        console.log("FileReader onload - immagine caricata");
        setAvatar(e.target.result);
        setImageLoaded(true);
      };
      reader.onerror = (error) => {
        console.error("Errore nel caricamento del file:", error);
        alert("Errore nel caricamento dell'immagine. Riprova.");
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageReady = () => {
    console.log("AvatarEditor - immagine pronta");
    setImageLoaded(true);
  };

  const handleImageError = (error) => {
    console.error("Errore AvatarEditor:", error);
    alert("Errore nel rendering dell'immagine. Prova con un'altra immagine.");
    setAvatar(null);
  };

  const handleScaleChange = (e) => {
    const scale = parseFloat(e.target.value);
    setScale(scale);
  };

  const handleSave = () => {
    if (editorRef.current) {
      const canvas = editorRef.current.getImageScaledToCanvas();
      canvas.toBlob((blob) => {
        const fileReader = new FileReader();
        fileReader.onload = () => {
          setAvatar(fileReader.result);
        };
        fileReader.readAsDataURL(blob);
      });
    }
  };

  return (
    <div className="editavatar">
      {avatar ? (
        <div className="editavatar-content">
          {!imageLoaded && (
            <div className="editavatar-loading">Caricamento immagine...</div>
          )}
          <AvatarEditor
            ref={editorRef}
            image={avatar}
            width={198}
            height={258}
            border={10}
            color={[61, 90, 76, 0.6]}
            scale={scale}
            rotate={0}
            borderRadius={0}
            onImageReady={handleImageReady}
            onLoadFailure={handleImageError}
            crossOrigin="anonymous"
            style={{ display: imageLoaded ? "block" : "none" }}
          />
          {imageLoaded && (
            <div className="editavatar-buttons">
              <label>Zoom</label>
              <input
                type="range"
                min="1"
                max="3"
                step="0.01"
                value={scale}
                onChange={handleScaleChange}
              />
              <button onClick={handleSave}>Salva Avatar</button>
              <button onClick={() => setAvatar(null)}>Cancella Avatar</button>
            </div>
          )}
        </div>
      ) : (
        <Dropzone
          onDrop={handleDrop}
          accept={{ "image/*": [".png", ".jpg", ".jpeg", ".gif", ".webp"] }}
          maxSize={5242880}
        >
          {({ getRootProps, getInputProps, isDragActive }) => (
            <div
              {...getRootProps()}
              className={`editavatar-dropzone ${isDragActive ? "active" : ""}`}
            >
              <input {...getInputProps()} />
              {isDragActive ? (
                <p>Rilascia l'immagine qui...</p>
              ) : (
                <p>
                  Trascina un'immagine qui o fai clic per selezionarla
                  <br />
                  <span style={{ fontSize: "11px", opacity: 0.7 }}>
                    (Max 5MB)
                  </span>
                </p>
              )}
            </div>
          )}
        </Dropzone>
      )}
    </div>
  );
};

export default AvatarUploader;
